import {
  ChartTitleDescription,
  ChartTitleHeader,
  ChartTitleStyled,
} from './ChartTitleAndDescription.styles';
import { ReactNode } from 'react';
interface Props {
  chartTitle: string;
  chartTitleDescription?: string | ReactNode;
  'data-testid'?: string;
}

export const ChartTitleAndDescription = ({
  chartTitle,
  chartTitleDescription,
  ...props
}: Props) => (
  <ChartTitleStyled>
    <ChartTitleHeader data-testid={`${props['data-testid'] ?? 'chart-title'}`}>
      {chartTitle}
    </ChartTitleHeader>
    {chartTitleDescription && typeof chartTitleDescription === 'string' ? (
      <ChartTitleDescription
        data-testid={`${props['data-testid'] ?? 'chart-title'}-description`}
      >
        {chartTitleDescription}
      </ChartTitleDescription>
    ) : (
      chartTitleDescription
    )}
  </ChartTitleStyled>
);
